import {Pipe, PipeTransform} from "@angular/core";
import {ExternalNumberAction} from "../../model/externalNumberAction";

@Pipe({name: 'numberAction'})
export class NumberAction implements PipeTransform {
    transform(value: any) {
        return ExternalNumberAction[value];
    }
}
